import { isArray } from 'util';
import { ErpTask } from '../erp-task';

export class ErpTaskBuilder {
  static fromJson(json) {
    return (json)
      ? new ErpTask(
        json.code,
        json.name,
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ErpTaskBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/erp-task.builder.ts